import type { SdsBinderPdfProps } from "./SdsBinderPdf";

export type RenderSdsBinderPdfResult = { ok: true; blob: Blob } | { ok: false; error: string };

/** Lazy-load binder PDF (cover + TOC + per-material sheets). */
export async function renderSdsBinderPdfToBlob(
  args: SdsBinderPdfProps
): Promise<RenderSdsBinderPdfResult> {
  try {
    const [{ pdf }, { SdsBinderPdf }] = await Promise.all([
      import("@react-pdf/renderer"),
      import("./SdsBinderPdf"),
    ]);
    const blob = await pdf(SdsBinderPdf(args)).toBlob();
    return { ok: true, blob };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : "Failed to render SDS binder PDF",
    };
  }
}
